import { type ThemeConfig } from "antd";

/**
 * Shared so that React roots mounted outside the app tree - EditorJS block tools, for one - can
 * re-provide the same theme instead of falling back to antd's defaults.
 */
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: "#978365",
    fontFamily: "Inter",
  },
};
